module.exports = __webpack_public_path__ + "static/5-bee29618a25bb1094740b04ced9021b3.png";